import {cloneDeep} from "lodash";
import {getString} from "Core/helpers/data";
import {CustomerCustomFieldsListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {CustomerCustomFieldsListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new CustomerCustomFieldsListItemDataObject(
		getString(result, 'customerCustomFieldId'),
		getString(result, 'name'),
		getString(result, 'description'),
		getString(result, 'type'),
	);

	return result;
}

// @note There is no output function since list is read only.